// extracted by mini-css-extract-plugin
export default {"botao":"BotaoTabela_botao__Kbuev","ativo":"BotaoTabela_ativo__mhXlF","tooltip":"BotaoTabela_tooltip__083Br"};